import React,{ useState } from 'react';
import ReactDOM from 'react-dom';


const Howtousenew = () => {


   const handleClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "2";
      document.getElementById('howTousePopup').style.zIndex = "2";


   };
   const exploreClick = () => {
      document.getElementById('howToUSE').style.display = "none";
      document.getElementById('howTousePopup').style.display = "none";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#006BBD";
      document.getElementById('howToUSE').style.zIndex = "-1";
      document.getElementById('howTousePopup').style.zIndex = "-1";

   };

   const howTouse = {
      display: 'none',
      position: 'fixed',
      top: '0',
      left: '0',
      height: '100vh',
      width: '100%',
      backgroundColor: 'white'
   }
   const mobHowToUseMain = {
      display: 'none',
      position: 'fixed',
      top: '0',
      height: '100vh',
      width: '100%',
      backgroundColor: 'white',
      zIndex: '2'
   }
   const mainDiv = {
      display: 'flex',
      position: 'absolute',
      left: '51%',
      top: '40%',
      transform: 'translate(-50%,-40%)',

   }
   const allThreeDiv = {
      textAlign: 'center',
      margin: '0px 40px 0 20px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '20px',
      lineHeight: '36px'
   }
   const mobAllthreeDiv = {
      textAlign: 'left',
      margin: '23px 0px 33px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
      lineHeight: '36px',
      width: '350px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
   }

   const mobAllthreeDivs = {
      textAlign: 'left',
      margin: '57px 0px 33px 0px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
      lineHeight: '36px',
      width: '350px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
   }
   const exploreButtton = {

      position: 'absolute',
      left: '50%',
      top: '225px',
      transform: 'translate(-50%, 100%)',
      cursor: 'pointer',
      height: '44px',
      width: '513px',
      background: '#0076CE',
      borderRadius: '2px',
      alignItems: 'center',
      textAlign: 'center',

      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '36px',
      color: '#FFFFFF',
      border: '0'

   }
   const mobExploreButtton = {
      position: 'absolute',
      left: '50%',
      top: '425px',
      transform: 'translate(-50%, 100%)',
      cursor: 'pointer',
      height: '54px',
      width: '253px',
      background: '#0076CE',
      borderRadius: '2px',
      alignItems: 'center',
      textAlign: 'center',

      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '36px',
      color: '#FFFFFF',
      border: '0'

   }
   const howToUseText = {
      position: 'absolute',
      left: '50%',
      top: '-40px',
      transform: 'translate(-50%, 100%)',
      alignItems: 'center',
      textAlign: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '38px',
      lineHeight: '56px',
      color: '#000000'
   }
   const mobHowToUseText = {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%, 100%)',
      alignItems: 'center',
      textAlign: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '40px',
      lineHeight: '56px',
      color: '#000000',
      width: '300px'
   }
   const closeUseMob = {
      position: 'absolute',
      right: '-2px',
      top: '-84px',
      color: '#CCCCCC',
      height: '32px',
      width: '32px',
      cursor: 'pointer'
   }
   const usestyle = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '16px',
      position: 'relative',
      left: '17px',
      top: '-4px'
   }
   const iconStyle = {
      transform: ' rotate(180deg)',
      position: 'relative',
      left: '-2px',
      top: '2px',
      color: '#006BBD',
      height: '22px',
      width: '22px'
   }
   const mobHowToUse = {
      display: 'flex',
      flexWrap: 'wrap',
      position: 'absolute',
      left: '50%',
      top: '40%',
      transform: 'translate(-50%,-40%)',
   }

   return (
      <React.Fragment>


         {ReactDOM.createPortal(

            <div>



               <div id="howToUSE" style={mobHowToUseMain} className='mobHowToUse'>

                  <div style={mobHowToUse}>
                     <a className="closeUseMob" onClick={exploreClick}><img tabIndex="1" id="closeBtn" alt="closeBtn" src="./images/cross.svg" /></a>


                     <span style={mobHowToUseText} id="mobHowToUseText">How to use</span>
                     <div style={mobAllthreeDivs} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: 'break-all' }} id="move_how_to_use">Move</span><img style={{ marginLeft: '62px',height: '76px',width: '166px' }} alt="moves" src="images/move.svg" /></div>
                     <div style={mobAllthreeDiv} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: 'break-all' }} id="rotate_how_to_use">Rotate</span><img style={{ marginLeft: '57px',height: '76px',width: '166px' }} alt="rotates" src="images/rotate.svg" /></div>
                     <div style={mobAllthreeDiv} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: 'break-all' }} id="zoom_how_to_use">Zoom</span><img style={{ marginLeft: '62px',height: '76px',width: '166px' }} alt="zommss" src="images/zoom.svg" /></div>
                     <button type='button' style={mobExploreButtton} onClick={exploreClick} id="exploreButtton1">Explore Product in 3D </button>
                  </div>

               </div>

            </div>,document.getElementById('howTousePopup')
         )}
      </React.Fragment>

   )
}



export default Howtousenew;

